/* Front wing scroll story — scroll-scrubbed choreography, B Motorsports.
   Progress p runs 0..1 while the stage is pinned. Everything below is a keyframe
   table over p; nothing is time-based, so it never gets out of sync with the scroll. */
(function () {
  if (customElements.get('front-wing-scroll')) return;

  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  var smooth = function (t) { return t * t * (3 - 2 * t); };
  // Interpolate a keyframe table [[p, value], ...] at p with per-segment smoothing.
  var kf = function (p, table) {
    if (p <= table[0][0]) return table[0][1];
    for (var i = 1; i < table.length; i++) {
      if (p <= table[i][0]) {
        var a = table[i - 1], b = table[i];
        var t = (p - a[0]) / (b[0] - a[0] || 1);
        return a[1] + (b[1] - a[1]) * smooth(t);
      }
    }
    return table[table.length - 1][1];
  };
  // Fade window: 0 before start, ramps in, holds, ramps out, 0 after end.
  var win = function (p, start, end, inLen, outLen, hold) {
    if (p < start) return 0;
    if (p > end) return hold ? 1 : 0;
    var i = clamp((p - start) / inLen, 0, 1);
    var o = hold ? 1 : clamp((end - p) / outLen, 0, 1);
    return smooth(Math.min(i, o));
  };

  // Desktop choreography. Units: vw/vh for translation, degrees, unitless scale.
  var K = {
    // Rise from below the fold to the centre, hold, then slide to one side and stay there.
    ty:    [[0, 72], [0.16, 0], [1, 0]],
    tx:    [[0, 0], [0.26, 0], [0.36, 12], [1, 12]],
    scale: [[0, 0.55], [0.16, 1], [1, 1]],
    head:  [[0, 1], [0.05, 1], [0.12, 0], [1, 0]],
    headY: [[0, 0], [0.12, -8], [1, -8]],
    sweep: [[0, 0], [0.06, 0], [0.12, 0.9], [0.3, 0], [1, 0]],
    sweepX:[[0.06, -60], [0.3, 60], [1, 60]],
    glow:  [[0, 0], [0.7, 0], [0.86, 0.45], [1, 0.45]],
    shadow:[[0, 0], [0.12, 0.8], [1, 0.8]]
  };

  var FrontWingScroll = function () { return Reflect.construct(HTMLElement, [], FrontWingScroll); };
  FrontWingScroll.prototype = Object.create(HTMLElement.prototype);
  FrontWingScroll.prototype.constructor = FrontWingScroll;

  FrontWingScroll.prototype.connectedCallback = function () {
    var self = this;
    this.stage = this.querySelector('.fws-stage');
    this.wing = this.querySelector('.fws-wing');
    this.imgA = this.querySelector('.fws-img--a');
    this.imgB = this.querySelector('.fws-img--b');
    this.sweep = this.querySelector('.fws-sweep');
    this.scan = this.querySelector('.fws-scan');
    this.glow = this.querySelector('.fws-glow');
    this.shadow = this.querySelector('.fws-shadow');
    this.headline = this.querySelector('.fws-headline');
    this.chapters = Array.prototype.map.call(this.querySelectorAll('.fws-chapter'), function (el) {
      return {
        el: el,
        start: (parseFloat(el.dataset.start) || 0) / 100,
        end: (parseFloat(el.dataset.end) || 100) / 100,
        hold: el.dataset.hold === 'true'
      };
    });

    this.startCountdown();

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !this.wing) { this.classList.add('is-static'); return; }

    this.motion = parseFloat(getComputedStyle(this).getPropertyValue('--fws-motion')) || 1;
    this.single = this.dataset.single === 'true' || !this.imgB;
    // Which side the product parks on after the rise; chapters sit on the other side.
    this.sideSign = this.dataset.side === 'left' ? -1 : 1;
    this.ticking = false;
    this.onScroll = function () {
      if (self.ticking) return;
      self.ticking = true;
      requestAnimationFrame(function () { self.ticking = false; self.update(); });
    };
    this.onResize = function () { self.mobile = window.innerWidth < 750; self.update(); };
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
    // rAF stalls in background tabs; resync when the page becomes visible again or is restored from bfcache.
    document.addEventListener('visibilitychange', function () { if (!document.hidden) self.onResize(); });
    window.addEventListener('pageshow', this.onResize);
    this.onResize();

    // Theme editor: re-run when the section is re-selected / re-rendered.
    document.addEventListener('shopify:section:load', function () { self.onResize(); });
  };

  FrontWingScroll.prototype.disconnectedCallback = function () {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    if (this.cdTimer) clearInterval(this.cdTimer);
  };

  // Countdown: one target per section, rendered in every [data-countdown] box inside it.
  // Stays hidden unless data-countdown-to parses to a real date, so there is never a fake timer.
  // Launch button: "Coming soon" (not clickable) until the countdown ends, then the live label + product link.
  FrontWingScroll.prototype.setLaunch = function (live) {
    var btns = this.querySelectorAll('[data-launch]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (live && b.dataset.liveHref) {
        b.textContent = b.dataset.liveLabel || b.dataset.soonLabel;
        b.setAttribute('href', b.dataset.liveHref);
        b.removeAttribute('aria-disabled');
        b.classList.remove('is-soon');
      } else {
        b.textContent = b.dataset.soonLabel;
        b.setAttribute('href', '#');
        b.setAttribute('aria-disabled', 'true');
        b.classList.add('is-soon');
      }
    }
  };

  FrontWingScroll.prototype.startCountdown = function () {
    var self = this;
    var boxes = this.querySelectorAll('[data-countdown]');
    var raw = (this.dataset.countdownTo || '').trim();
    // No countdown configured: the button goes straight to its live state.
    if (!raw) { this.setLaunch(true); return; }
    var target = Date.parse(raw);
    if (isNaN(target)) { this.setLaunch(true); return; }
    if (!boxes.length) { this.setLaunch(Date.now() >= target); return; }
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var setCell = function (box, k, v) {
      var el = box.querySelector('[data-cd="' + k + '"]');
      if (el) el.textContent = v;
    };
    var tick = function () {
      var left = target - Date.now();
      var done = left <= 0;
      for (var i = 0; i < boxes.length; i++) {
        var b = boxes[i];
        b.hidden = false;
        var cells = b.querySelector('.fws-countdown__cells');
        var doneEl = b.querySelector('[data-cd="done"]');
        if (done) {
          if (cells) cells.hidden = true;
          if (doneEl) doneEl.hidden = false;
          continue;
        }
        setCell(b, 'd', pad(Math.floor(left / 86400000)));
        setCell(b, 'h', pad(Math.floor(left / 3600000) % 24));
        setCell(b, 'm', pad(Math.floor(left / 60000) % 60));
        setCell(b, 's', pad(Math.floor(left / 1000) % 60));
      }
      self.setLaunch(done);
      if (done && self.cdTimer) { clearInterval(self.cdTimer); self.cdTimer = null; }
    };
    tick();
    this.cdTimer = setInterval(tick, 1000);
  };

  FrontWingScroll.prototype.progress = function () {
    var r = this.getBoundingClientRect();
    var total = r.height - window.innerHeight;
    if (total <= 0) return 0;
    return clamp(-r.top / total, 0, 1);
  };

  FrontWingScroll.prototype.update = function () {
    var p = this.progress();
    var m = this.motion;
    var mob = this.mobile;
    this.style.setProperty('--fws-p', p.toFixed(4));

    // Product transform: translate and scale only, no rotation.
    var tx = kf(p, K.tx) * m * this.sideSign * (mob ? 0.25 : 1);
    var ty = kf(p, K.ty) * m;
    var sc = kf(p, K.scale);
    if (mob) sc = 1 + (sc - 1) * 0.75;
    sc = 1 + (sc - 1) * Math.min(m, 1.2);
    this.wing.style.transform =
      'translate3d(calc(-50% + ' + tx.toFixed(2) + 'vw), calc(-50% + ' + ty.toFixed(2) + 'vh), 0) ' +
      'scale(' + sc.toFixed(4) + ')';

    // Two-image mode (optional): a straight cut to the second image once the product has parked.
    if (!this.single && this.imgB) {
      var swap = p >= 0.6;
      this.imgB.style.clipPath = 'none';
      this.imgB.style.opacity = swap ? '1' : '0';
      this.imgA.style.opacity = swap ? '0' : '1';
      if (this.scan) this.scan.style.opacity = '0';
    }

    // Light sweep
    if (this.sweep) {
      this.sweep.style.opacity = kf(p, K.sweep).toFixed(3);
      this.sweep.style.transform = 'translateX(' + kf(p, K.sweepX).toFixed(1) + '%)';
    }
    if (this.glow) this.glow.style.opacity = kf(p, K.glow).toFixed(3);
    if (this.shadow) this.shadow.style.opacity = kf(p, K.shadow).toFixed(3);

    // Opening headline
    if (this.headline) {
      var h = kf(p, K.head);
      this.headline.style.opacity = h.toFixed(3);
      this.headline.style.transform = 'translateY(' + kf(p, K.headY).toFixed(2) + 'vh)';
      this.headline.style.visibility = h < 0.01 ? 'hidden' : 'visible';
    }

    // Chapters
    for (var i = 0; i < this.chapters.length; i++) {
      var c = this.chapters[i];
      var len = Math.max(c.end - c.start, 0.02);
      var o = win(p, c.start, c.end, len * 0.3, len * 0.25, c.hold);
      c.el.style.opacity = o.toFixed(3);
      var drift = (1 - o) * (p < (c.start + c.end) / 2 ? 1 : -1) * 28;
      var base = c.el.classList.contains('fws-chapter--center')
        ? (mob ? '' : 'translateX(-50%)') + (c.el.classList.contains('fws-cta') ? '' : ' translateY(-50%)')
        : (mob ? '' : 'translateY(-50%)');
      c.el.style.transform = base + ' translateY(' + drift.toFixed(1) + 'px)';
      c.el.style.pointerEvents = o > 0.6 ? 'auto' : 'none';
      c.el.style.visibility = o < 0.005 ? 'hidden' : 'visible';
    }
  };

  customElements.define('front-wing-scroll', FrontWingScroll);
})();
